import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	dismissAriaLabel: {
		id: 'offerBanner.dismiss.ariaLabel',
		defaultMessage: 'close',
		description: 'Accessible label for the button that dismisses the promo banner',
	},
});
